import React, { useEffect } from "react";
import TriageAssessmentCard from "./TriageAssessmentCard";
import { Col, Row } from "react-bootstrap";
import VitalSignCard from "./VitalSignCard";
import { useDispatch, useSelector } from "react-redux";
import { ageCalculator, getToday } from "helpers/utils";
import { useSearchParams } from "react-router-dom";

import Systolic from "../../../assets/img/blood-pressure.svg";
import Diastolic from "../../../assets/img/blood-pressure-check.svg";
import Weight from "../../../assets/img/sport.png";
import AdmissionWeight from "../../../assets/img/weight-loss.png";
import Height from "../../../assets/img/height.svg";
import Oxygen from "../../../assets/img/oxygen-saturation.svg";
import BirthWeight from "../../../assets/img/bathroom-scale.png";
import Respiratory from "../../../assets/img/respiratory-system.svg";
import Pulse from "../../../assets/img/pulse.svg";
import {
  GetAllEncounterClass,
  GetAllEncounterInfo,
  GetAllSpecilaity,
  GetMissingTooth,
} from "../config/preauthorizationApi";

const TriageAssessment = ({ setValue, watch, control }) => {
  const dispatch = useDispatch();
  const {
    stepFormData,
    encounterClass,
    discharegSpeciality,
    serviceTypeListEncounter,
    missingTeethList,
    triageCategoryList,
    missingTeethListReason,
    actPeriortyList,
    departmentDispositionList,
    lengthOfStayList,
    viewPreauthorizationInfo,
    emergencyArrivalList,
    encounterStatusList,
    adminResourceList,
    dischargeDispositionList,
    eventTypeList,
    admissionSpeciality,
  } = useSelector((state) => state.preauthorization);
  const birthDate = stepFormData?.birth_date;
  const preauthType = stepFormData?.preauthorization_type;

  const preauthRequest = viewPreauthorizationInfo?.provider_request;
  const preauthVitals = preauthRequest?.vitals;
  const preauthEncounter = preauthRequest?.encounter;
  const preauthMedical = preauthRequest?.medical_details;

  const { age } = ageCalculator(
    stepFormData?.new_born ? stepFormData?.child_birth_date : birthDate
  );

  const year = age?.years;

  const addmissionBirthCond =
    year < 1 &&
    (preauthType?.claim_types_name === "Institutional" ||
      preauthType?.claim_types_name === "Professional");

  const [searchParams] = useSearchParams();
  const reuse = searchParams.get("reuse") === "true";
  const edit = searchParams.get("edit") === "true";
  const followUp = searchParams.get("followup") === "true";

  useEffect(() => {
    if (discharegSpeciality?.length === 0) dispatch(GetAllSpecilaity());
    if (encounterStatusList?.length === 0) dispatch(GetAllEncounterInfo());
    if (encounterClass?.length === 0) dispatch(GetAllEncounterClass());
    if (missingTeethList?.length === 0) {
      dispatch(GetMissingTooth());
    }
  }, []);

  useEffect(() => {
    setValue(
      "act_priority",
      actPeriortyList?.find((item) => item?.enctalltyp_code == "EL")
    );
    if (reuse || edit || followUp) {
      let tempValue = watch("temperature") || preauthVitals?.temperature;
      if (tempValue) {
        const numVal = parseFloat(tempValue);
        if (isNaN(numVal) || numVal < 34.5 || numVal > 46.5) {
          tempValue = "";
        }
      }
      setValue("temperature", tempValue);

      let weightValue = watch("weight") || preauthVitals?.height;
      if (weightValue) {
        const numVal = parseFloat(weightValue);
        if (isNaN(numVal) || numVal < 1 || numVal > 635.5) {
          weightValue = "";
        }
      }
      setValue("weight", weightValue);

      let admWeightValue =
        watch("admission_weight") || preauthVitals?.admissionweight;

      if (admWeightValue) {
        const numVal = parseFloat(admWeightValue);
        if (isNaN(numVal) || numVal < 1 || numVal > 635.5) {
          admWeightValue = "";
        }
      }
      setValue("admission_weight", admWeightValue);

      let birthWeightValue =
        watch("birth_weight") || preauthVitals?.birthweight;
      console.log({ birthWeightValue });
      if (birthWeightValue) {
        const numVal = parseFloat(birthWeightValue);
        if (isNaN(numVal) || numVal < 1 || numVal > 635.5) {
          birthWeightValue = "";
        }
      }
      setValue("birth_weight", birthWeightValue);

      let heightValue = watch("height") || preauthVitals?.height;
      if (heightValue) {
        const numVal = parseFloat(heightValue);
        if (isNaN(numVal) || numVal < 1 || numVal > 275.5) {
          heightValue = "";
        }
      }
      setValue("height", heightValue);

      let pulseValue = watch("pulse") || preauthVitals?.pulse;
      if (pulseValue) {
        const numVal = parseFloat(pulseValue);
        if (isNaN(numVal) || numVal < 40 || numVal > 220) {
          pulseValue = "";
        }
      }
      setValue("pulse", pulseValue);

      let sysBpValue =
        watch("systolic_blood_pressure") || preauthVitals?.systolic;
      if (sysBpValue) {
        const numVal = parseFloat(sysBpValue);
        if (isNaN(numVal) || numVal < 40 || numVal > 220) {
          sysBpValue = "";
        }
      }
      setValue("systolic_blood_pressure", sysBpValue);

      let diaBpValue =
        watch("diastolic_blood_pressure") || preauthVitals?.diastolic;
      if (diaBpValue) {
        const numVal = parseFloat(diaBpValue);
        if (isNaN(numVal) || numVal < 40 || numVal > 150) {
          diaBpValue = "";
        }
      }
      setValue("diastolic_blood_pressure", diaBpValue);

      let o2Value =
        watch("oxygen_saturation") || preauthVitals?.oxygensaturation;
      if (o2Value) {
        const numVal = parseFloat(o2Value);
        if (isNaN(numVal) || numVal < 0 || numVal > 100) {
          o2Value = "";
        }
      }
      setValue("oxygen_saturation", o2Value);

      let respValue =
        watch("respiratory_rate") || preauthVitals?.respiratoryrate;
      if (respValue) {
        const numVal = parseFloat(respValue);
        if (isNaN(numVal) || numVal < 10 || numVal > 70) {
          respValue = "";
        }
      }
      setValue("respiratory_rate", respValue);

      setValue(
        "admission_date",
        watch("admission_date") || reuse
          ? new Date(getToday())
          : new Date(getToday()) || null
      );

      setValue(
        "discharge_date",
        watch("discharge_date") || preauthEncounter?.enct_eddate
          ? new Date(getToday())
          : ""
      );
      setValue(
        "triage_date",
        watch("triage_date") || preauthEncounter?.enct_trgdte
          ? preauthEncounter?.enct_trgdte
          : ""
      );
      setValue(
        "triage_category",
        watch("triage_category") ||
        triageCategoryList?.find(
          (item) =>
            item?.enctalltyp_code === preauthEncounter?.enct_trgctgcode
        )
      );
      setValue(
        "emer_department_disposition",
        watch("emer_department_disposition") ||
        departmentDispositionList?.find(
          (item) =>
            item?.enctalltyp_code === preauthEncounter?.enct_emrgdeptdispcode
        )
      );
      setValue(
        "emergncy_arrival_code",
        watch("emergncy_arrival_code") ||
        emergencyArrivalList?.find(
          (item) =>
            item?.enctalltyp_code === preauthEncounter?.enct_emrgdeptdispcode
        )
      );
      setValue(
        "care_type",
        watch("care_type") ||
        serviceTypeListEncounter?.find(
          (item) =>
            item?.enctalltyp_code === preauthEncounter?.enct_servtypecode
        )
      );

      setValue(
        "encounter_class",
        watch("encounter_class") ||
        encounterClass?.find(
          (item) => item?.act_code?.toLowerCase() === preauthEncounter?.enct_clscode?.toLowerCase()
        ) ||
        null
      );

      setValue(
        "encounter_status",
        watch("encounter_status") ||
        encounterStatusList?.find(
          (item) => item?.enctalltyp_code === preauthEncounter?.enct_status
        ) ||
        null
      );

      setValue("cause_of_death", watch("cause_of_death") || "");

      setValue(
        "service_event_type",
        watch("service_event_type") ||
        eventTypeList?.find(
          (item) =>
            item?.enctalltyp_code === preauthEncounter?.enct_sevnttypcode
        ) ||
        null
      );

      setValue("care_type", watch("care_type") || "");

      setValue(
        "discharge_speciality",
        watch("discharge_speciality") ||
        discharegSpeciality?.find(
          (item) =>
            item?.specialities_code ===
            preauthEncounter?.enct_discgspecltycode
        ) ||
        null
      );

      setValue(
        "admission_speciality",
        watch("admission_speciality") ||
        admissionSpeciality?.find(
          (item) =>
            item?.specialities_code === preauthEncounter?.enct_admnspecltycode
        ) ||
        null
      );

      setValue(
        "encounter_admitsource",
        watch("encounter_admitsource") ||
        adminResourceList?.find(
          (item) =>
            item?.enctalltyp_code === preauthEncounter?.enct_admsrcecode
        ) ||
        null
      );
      setValue(
        "emergency_service_start_date",
        watch("emergency_service_start_date") ||
          preauthEncounter?.enct_emergservst
          ? preauthEncounter?.enct_emergservst
          : ""
      );

      setValue(
        "discharge_disposition",
        watch("discharge_disposition") ||
        dischargeDispositionList?.find(
          (item) =>
            item?.enctalltyp_code === preauthEncounter?.enct_disdispcode
        ) ||
        null
      );

      setValue(
        "estimated_length_stay",
        watch("estimated_length_stay") || preauthVitals?.lengthofstay || null
      );

      setValue(
        "intend_length_stay",
        watch("intend_length_stay") ||
        lengthOfStayList?.find(
          (item) =>
            item?.enctalltyp_code === preauthEncounter?.enct_intdlghstycode
        ) ||
        null
      );

      setValue(
        "last_menstrual_code",
        watch("last_menstrual_code") ||
        preauthEncounter?.menstrualperiod ||
        null
      );

      // These are date fields without fallback lists, set directly
      setValue(
        "empoly_impact_start_date",
        watch("empoly_impact_start_date") || reuse ? new Date(getToday()) : ""
      );

      setValue(
        "empoly_impact_end_date",
        watch("empoly_impact_end_date") || reuse ? new Date(getToday()) : ""
      );

      setValue(
        "chief_complaint",
        watch("chief_complaint") || preauthMedical?.chiefcomplaint
      );
      setValue("icu_hours", watch("icu_hours") || preauthVitals?.icuhours);
      setValue(
        "ventilation_hours",
        watch("ventilation_hours") || preauthVitals?.ventilationhours
      );
      setValue(
        "treatment_plan",
        watch("treatment_plan") || preauthMedical?.treatmentplan
      );
      setValue(
        "patient_history",
        watch("patient_history") || preauthMedical?.patienthistory
      );
      setValue(
        "physical_examination",
        watch("physical_examination") || preauthMedical?.physicalexamination
      );
      setValue(
        "history_present_illness",
        watch("history_present_illness") ||
        preauthMedical?.historypresentillness
      );
      setValue(
        "significant_sign",
        watch("significant_sign") || preauthMedical?.significantsigns
      );
      setValue(
        "clinical_data",
        watch("clinical_data") || preauthMedical?.clinicaldata
      );
      setValue(
        "other_conditions",
        watch("other_conditions") || preauthMedical?.otherconditions
      );
      setValue(
        "aspect_date",
        watch("aspect_date") || preauthMedical?.onsetdate
      );
      setValue(
        "missing_tooth",
        watch("missing_tooth") || preauthMedical?.missingtooth
      );
      setValue(
        "missing_tooth_number",
        watch("missing_tooth_number") ||
        missingTeethList?.find(
          (item) => item?.oral_code === preauthMedical?.missingtooth?.tooth_no
        )
      );
      setValue(
        "missing_tooth_date",
        watch("missing_tooth_date") || preauthMedical?.missingtooth?.date
      );
      setValue(
        "missing_reason",
        watch("missing_reason") ||
        missingTeethListReason?.find(
          (res) =>
            res?.msngtoothcde_code == preauthMedical?.missingtooth?.name
        )
      );
    } else if (stepFormData) {
      setValue("weight", stepFormData?.weight);
      setValue("admission_weight", stepFormData?.admission_weight);
      setValue("height", stepFormData?.height);
      setValue("pulse", stepFormData?.pulse);
      setValue(
        "systolic_blood_pressure",
        stepFormData?.systolic_blood_pressure
      );
      setValue(
        "diastolic_blood_pressure",
        stepFormData?.diastolic_blood_pressure
      );
      setValue("oxygen_saturation", stepFormData?.oxygen_saturation);
      setValue("respiratory_rate", stepFormData?.respiratory_rate);
      setValue("heart_rhythm", stepFormData?.heart_rhythm);
      setValue("temperature", stepFormData?.temperature);
    }
  }, [
    stepFormData,
    followUp,
    edit,
    actPeriortyList,
    reuse,
    encounterClass,
    preauthRequest,
    encounterStatusList,
    preauthEncounter,
    preauthMedical,
    preauthEncounter,
  ]);
  return (
    <Row>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <TriageAssessmentCard
          setValue={setValue}
          watch={watch}
          control={control}
          min={34.5}
          max={46.5}
          name="temperature"
          label={"Temperature"}
          subLabel={"°C"}
          required={false}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          label={"Weight"}
          name="weight"
          imageSrc={Weight}
          subLabel={"KG"}
          background={"badge-subtle-success"}
          control={control}
          min={1}
          max={635.5}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          label={"Admission Weight"}
          name="admission_weight"
          imageSrc={AdmissionWeight}
          background={"badge-subtle-success"}
          subLabel={"KG"}
          control={control}
          min={1}
          max={635.5}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          label={"Birth Weight"}
          name="birth_weight"
          imageSrc={BirthWeight}
          subLabel={"KG"}
          required={addmissionBirthCond}
          background={"badge-subtle-primary"}
          control={control}
          min={1}
          max={635.5}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          label={"Height"}
          name="height"
          subLabel={"Cm"}
          background={"badge-subtle-success"}
          control={control}
          imageSrc={Height}
          min={1}
          max={275.5}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          imageSrc={Pulse}
          background={"badge-subtle-danger"}
          label={"Pulse"}
          name="pulse"
          subLabel={"min"}
          control={control}
          min={40}
          max={220}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          label={"Systolic B.P"}
          imageSrc={Systolic}
          name="systolic_blood_pressure"
          subLabel={"mmHg"}
          control={control}
          background={"badge-subtle-danger"}
          min={40}
          max={220}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          imageSrc={Diastolic}
          label={"Diastolic B.P"}
          name="diastolic_blood_pressure"
          subLabel={"mmHg"}
          control={control}
          background={"badge-subtle-warning"}
          min={40}
          max={150}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          label={"O2 Saturation"}
          name="oxygen_saturation"
          imageSrc={Oxygen}
          subLabel={"%"}
          background={"badge-subtle-warning"}
          control={control}
          min={0}
          max={100}
        />
      </Col>
      <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          label={"Respiratory Rate"}
          name="respiratory_rate"
          subLabel={"min"}
          control={control}
          min={10}
          background={"badge-subtle-primary"}
          max={70}
          imageSrc={Respiratory}
        />
      </Col>
      {/* <Col xs={12} sm={6} md={3} className="mb-2">
        <VitalSignCard
          setValue={setValue}
          watch={watch}
          label={"Heart Rhythm"}
          name="heart_rhythm"
          subLabel={"bpm"}
          control={control}
          dropdown={true}
          background={"rgba(111, 66, 193, 0.1)"}
        />
      </Col> */}
    </Row>
  );
};

export default TriageAssessment;
